import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import Rendertable from "./Rendertable";
import { getProductSearchResultforsales, getAllAuditReport } from "../../../actions/productDetails";
import {
  getAllLocation,
  getAllLocationPlain,
} from "../../../actions/warehouseAction";
import { getAllCategory } from "../../../actions/categoryAction";
import { getAllTag } from "../../../actions/Inventory/tagAction";
import { getAllBrand } from "../../../actions/Inventory/brandAction";
import { getAllAttributeTerm , getAllAttribute  } from "../../../actions/attributeAction";


import {
  Divider,
  AutoComplete,
  Row,
  Col,
  Select,
  Skeleton,
  TreeSelect,
  Button,
  InputNumber,
  Checkbox
} from "antd";
const { Option } = Select;

const SearchStock = ({
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  categoryList,
  getAllCategory,
  getAllAttributeTerm,
  attributeTerms,
  getAllAttribute,
  attributes,
  getAllTag,
  getAllBrand,
  tags,
  brands,
  getAllAuditReport,
}) => {
  const [List, setList] = useState([]);
  const [locations, setLocations] = useState([]);
  const [reload, setreload] = useState(false);
  const [loading, setloading] = useState(true);
  const location = useRef("");
  const keyward = useRef("");
  const pageno = useRef(1);
  const page_size = useRef(10);
  let total_data = useRef({});
  

    useEffect(() => {
      console.log("Attribute Terms:", attributeTerms);
    }, [attributeTerms]);
    

  useEffect(() => {
    setloading(true)
    getAllAuditReport(
      pageno.current,
      page_size.current,
    ).then((result) => {
      setList(result);
      setloading(false);
    });
  }, [reload]);



  const renderdata = () => {
    if (loading) {
      return <Skeleton active />;
    } else {
      return (
        <Rendertable
          List={List}
          pageno={pageno}
          page_size={page_size}
          setreload={setreload}
          setloading={setloading}
          total_data={total_data}
        />
      );
    }
  };

  return (
    <>
      {renderdata()}
    </>
  );
};


export default connect(null, {
  getProductSearchResultforsales,
  getAllLocation,
  getAllLocationPlain,
  getAllCategory,
  getAllAttributeTerm,
  getAllAttribute,
  getAllTag,
  getAllBrand,
  getAllAuditReport,
})(SearchStock);
